import { readonly, ref } from 'vue';

export type TaskStatusPopupKind = 'overdue' | 'closedInTime';

export interface TaskStatusPopupItem {
  id: string;
  kind: TaskStatusPopupKind;
  createdAt: number;
}

const items = ref<TaskStatusPopupItem[]>([]);

function uid(): string {
  const c = globalThis.crypto as Crypto | undefined;
  if (c?.randomUUID) {
    return c.randomUUID();
  }
  return `${ Date.now() }-${ Math.random().toString(16).slice(2) }`;
}

export function pushTaskStatusPopup(kind: TaskStatusPopupKind): void {
  items.value = [
    ...items.value,
    {
      id: uid(),
      kind,
      createdAt: Date.now(),
    },
  ].slice(-3);
}

export function removeTaskStatusPopup(id: string): void {
  items.value = items.value.filter((x) => x.id !== id);
}

export function useTaskStatusPopups() {
  return {
    items: readonly(items),
    remove: removeTaskStatusPopup,
  };
}

